import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as Cliente from "../modelos/cliente.modelo";
import * as myGlobals from "../modelos/globales.modelo";
import { ApiAppService } from "../servicios/apiapp.service";
import { APP_VERSION } from '@environments/version';

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    standalone: false
})
export class AppComponent implements OnInit {
  title = "solicitarcitaprevia";
  public oCliente: Cliente.cCliente;
  public cargafinalizada: boolean;
  public lanzarOnInit: boolean;
  public sVersion: string;

  constructor(
    public oRouter: Router,
    public _activatedRoute: ActivatedRoute,
    public _ApiAppService: ApiAppService
  ) {
    // Limpiar sesión
    myGlobals.clearSessionStore();

    this.sVersion = APP_VERSION;
    this.cargafinalizada = false;
    this.lanzarOnInit = true;

    const sValoresGET = window.location.search;
    if (!myGlobals.isNullUndefinedVacio(sValoresGET)) {
      const urlParams = new URLSearchParams(sValoresGET);

      const sIdArea: string = urlParams.get("id_area") || "0";
      const sIdTramite: string = urlParams.get("id_tramite") || "0";
      const sNIF: string = urlParams.get("nif") || "";
      const sApellido1: string = urlParams.get("apellido1") || "";
      const sApellido2: string = urlParams.get("apellido2") || "";
      const sNombre: string = urlParams.get("nombre") || "";
      const sEmail: string = urlParams.get("email") || "";
      const sMovil: string = urlParams.get("movil") || "";
      const sAsunto: string = urlParams.get("asunto") || "";

      if (!myGlobals.isNullUndefinedVacio(sNIF)) {
        myGlobals.setSessionStore(myGlobals.eSessionStore.get_nif, sNIF);
        myGlobals.setSessionStore(
          myGlobals.eSessionStore.get_apellido1,
          sApellido1
        );
        myGlobals.setSessionStore(
          myGlobals.eSessionStore.get_apellido2,
          sApellido2
        );
        myGlobals.setSessionStore(myGlobals.eSessionStore.get_nombre, sNombre);
        myGlobals.setSessionStore(myGlobals.eSessionStore.get_email, sEmail);
        myGlobals.setSessionStore(myGlobals.eSessionStore.get_movil, sMovil);
        myGlobals.setSessionStore(myGlobals.eSessionStore.get_asunto, sAsunto);
        myGlobals.setSessionStore(myGlobals.eSessionStore.get_id_area, sIdArea);
        myGlobals.setSessionStore(
          myGlobals.eSessionStore.get_id_tramite,
          sIdTramite
        );

        if (sIdArea !== "0") {
          const citatemporal = {
            id_area: parseInt(sIdArea),
            id_tramite: parseInt(sIdTramite),
          };
          myGlobals.setSessionStore(
            myGlobals.eSessionStore.citatemporal,
            JSON.stringify(citatemporal)
          );
        }
      }
    }
  }

  ngOnInit() {
    this._ApiAppService.ObtenerClientePorToken().subscribe((data) => {
      if (data != null) {
        this.oCliente = data;
        myGlobals.setSessionStore(
          myGlobals.eSessionStore.id_cliente,
          JSON.stringify(this.oCliente.client.idcliente)
        );
        myGlobals.setSessionStore(
          myGlobals.eSessionStore.ocliente,
          JSON.stringify(this.oCliente)
        );
        myGlobals.setSessionStore(
          myGlobals.eSessionStore.nombrecliente,
          JSON.stringify(this.oCliente.client.nombre)
        );
      }
    });
    this.cargafinalizada = true;
    // Si recibiste parámetros de solicitante por GET, puedes redirigir a /citas directamente
    if (
      !myGlobals.isNullUndefinedVacio(
        myGlobals.getSessionStore(myGlobals.eSessionStore.get_nif)
      )
    ) {
      this.oRouter.navigateByUrl("/citas");
    }
  }

  // Nombre del cliente
  Cliente(): string {
    let sCliente: string = myGlobals.getNombreCliente();
    if (myGlobals.isNullUndefinedVacio(sCliente)) {
      sCliente = "Cliente Desconocido";
    }
    return sCliente;
  }

  // Comprueba si está accediendo la página de las citas
  PaginaCitas(): boolean {
    return this.oRouter.url.indexOf("citas") === 0;
  }

  getImagenAlt(): string {
    return myGlobals.getImagenAlt();
  }
  getImagenLogo(): string {
    return myGlobals.getImagenLogo();
  }
  getClienteLogado(): boolean {
    return !myGlobals.isNullUndefinedVacio(localStorage.getItem("AccessToken"));
  }

  getYear(): string {
    return new Date().getFullYear().toString();
  }
}
